import { base } from "./base";
import { events } from "./events";
import { modals } from "./modals";
import { pages } from "./pages";
import { telegram } from "./telegram";
import { terms } from "./terms";
import { widgets } from "./widgets";

export const ru = {
  ...base,
  ...events,
  ...pages,
  ...telegram,
  ...terms,
  ...modals,
  ...widgets,
};
